import di from 'Services/di.js';
import addTaskWindow from 'fsrc/AddTaskWindow/addTaskWindow.js';

export default async () => {
    events.emit('tasks__formAddTask:addNewTask', { type: 'task' });
};
